<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>
            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">标题</template>
                    {{ detail.title }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">分类</template>
                    {{ detail.category ? detail.category.name : '' }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">状态</template>
                    {{ detail.status_desc }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">总认领人数</template>
                    {{ detail.claim_num }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">已认领人数</template>
                    {{ detail.joined_num }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">截止时间</template>
                    {{ detail.end_time }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">创建时间</template>
                    {{ detail.create_time }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form">心愿内容</div>
            <el-descriptions class="margin-top" title="" :column="1" size="medium" border >
                <el-descriptions-item>
                    <template slot="label">图片</template>
                    <el-image style="height: 40px" fit="contain" v-if="detail.image_array" v-for="(item, index) in detail.image_array" :key="index" class="ya-img-table" :src="item.file_path"
                              :preview-src-list="[item.file_path]" title="点击查看大图"/>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">内容</template>
                    <div v-html="detail.content"></div>
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form" v-if="detail.audit">审核信息</div>
            <el-descriptions class="margin-top" title="" :column="1" size="medium" border v-if="detail.audit" >
                <el-descriptions-item>
                    <template slot="label">审核状态</template>
                    <div v-if="detail.audit.status === 1"> 审核通过 </div>
                    <div v-else> 审核不通过 </div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">审核时间</template>
                   {{ detail.audit.create_time }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">审核内容</template>
                    {{ detail.audit.remark }}
                </el-descriptions-item>
            </el-descriptions>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { wishDetail } from '@/api/education';

    export default {
        components: {},
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                wish_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.wish_id = row.wish_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            save() {
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            getDetail() {
                wishDetail({id: this.wish_id}).then((result) => {
                    this.detail = Object.assign({}, result.data)
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/wish/wish/detail.vue